// pages/ChatPage.jsx
import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import ChatBox from "../components/ChatBox/ChatBox";
import { AuthContext } from "../context/AuthContext";
import { fetchUserProfile } from "../utils/api";
import { useCall } from "../context/CallContext"; // ✅ FIX: Use Context, NOT Hook directly
import socket from "../utils/socket";
import "../css/chat.css";

export default function ChatPage() {
  const { user, token } = useContext(AuthContext);
  const { toId } = useParams();

  const selfId = user?._id || user?.id;
  const [room, setRoom] = useState("");
  const [receiverProfile, setReceiverProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ FIX: Get everything from Global Context (App.js wala logic)
  // Don't call useChatLogic() here again!
  const {
    messages,
    history,
    text,
    typing,
    inCall,
    calling,
    incomingCall,
    showProfile,
    localStream,
    remoteStream,
    chatRef,
    callType,
    setText,
    setShowProfile,
    sendMessage,
    handleTyping,
    startCall,
    acceptCall,
    rejectCall,
    endCall,
    setToId, // Need this to switch chat rooms
  } = useCall();

  // ✅ Tell Global Logic that we are in this specific chat
  useEffect(() => {
    setToId(toId);
    return () => setToId(null);
  }, [toId, setToId]);

  // Load Profile Logic (Keep as is)
  useEffect(() => {
    if (!selfId || !toId || !token) {
      setLoading(false);
      return;
    }

    const roomName = [String(selfId), String(toId)].sort().join("-");
    setRoom(roomName);

    // Note: joinRoom is handled globally now, but keeping this doesn't hurt for chat history fetch
    let mounted = true;
    fetchUserProfile(toId, token)
      .then((profile) => {
        if (!mounted) return;
        setReceiverProfile(profile);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load profile", err);
        if (!mounted) return;
        setReceiverProfile(null);
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [selfId, toId, token]);

  if (!token || !selfId) {
    return <p className="chat-error">❌ Please log in to access chat.</p>;
  }

  if (loading) {
    return <p className="chat-loading">⏳ Loading profile...</p>;
  }

  return (
    <div className="chat-page">
      <div className="chat-header">
        {receiverProfile ? (
          <p>💬 Chatting with: {receiverProfile.name || "User"}</p>
        ) : (
          <p className="chat-error">⚠️ Failed to load user profile.</p>
        )}
      </div>

      {receiverProfile && (
        <ChatBox
          user={user}
          toId={toId}
          room={room}
          token={token}
          receiverProfile={receiverProfile}
          // Pass global state
          messages={messages}
          history={history}
          text={text}
          typing={typing}
          inCall={inCall}
          calling={calling}
          incomingCall={incomingCall}
          showProfile={showProfile}
          localStream={localStream}
          remoteStream={remoteStream}
          chatRef={chatRef}
          callType={callType}
          setText={setText}
          setShowProfile={setShowProfile}
          sendMessage={sendMessage}
          handleTyping={handleTyping}
          startCall={startCall}
          acceptCall={acceptCall}
          rejectCall={rejectCall}
          endCall={endCall}
        />
      )}
    </div>
  );
}